import * as React from 'react'

export const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = (e?: MediaQueryListEvent) => {
      setIsMobile(e?.matches ?? mql.matches)
    }

    setIsMobile(mql.matches)

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    } else {
      mql.addListener(onChange)
      return () => {
        mql.removeListener(onChange)
      }
    }
  }, [])

  return !!isMobile
}
